<template>
  <div class="main-container">
    <!-- breadcrumb -->
     <breadcrumb 
    :list="breadcrumbList"/>
    <!-- breadcrumb -->

    <section class="main-content-section">
      <tl-tabs :tabs="tabs" :customclass="true" :showcount="false">
        <tl-tab>
          <fbp-settings />
        </tl-tab>
        <tl-tab>
          <!-- {{componentList}} -->
          <!-- <div v-if="!componentList.length">
            <div class="noData">
              <span>
                You have not added any Bands yet.
                <br />Click on Add Bands to add get started.
              </span>
            </div>
            <form-add-button
              main_text="Go to"
              sub_text="FBP Component"
              @click="goToAddFBPComponents()"
            ></form-add-button>
          </div> -->
          <div v-if="isEditClicked">
            <!-- <div class="row">
              <div class="col-3">
                <tl-select
                  label="FBP Components"
                  labelText="componentName"
                  :options="fbpComponentsList"
                  @change="onSelectFBPComponents($event)"
                ></tl-select>
              </div>
            </div> -->
            <!-- {{componentList[0]}} -->
            <data-table
            class="margintop-20"
              :columns="tableColumns"
              :tableData="componentList"
              :withForm="false"
              :showhistory="false"
              @editStart="editItem($event)"
            ></data-table>
          </div>
          <div v-if="!isEditClicked">
            <fbp-components
              :fbpRowData="rowData"
            ></fbp-components>
          </div>
        </tl-tab>
      </tl-tabs>
    </section>
  </div>
</template>
<script>
import FbpSettings from "./fbpSettings.vue";
import FbpComponents from "./FbpComponentsForm.vue";
import { mapGetters,mapActions } from "vuex";
export default {
  components: {
    FbpComponents,
    FbpSettings
  },
  data() {
    return {
      tabs: [
        {
          header: "FBP Settings"
        },
        {
          header: "FBP Components"
        }
      ],
      isEditClicked: true,
      rowData: {},
      fbpComponentsList: [
        {
          componentName: "Basic Salary",
          value: "basicSalary"
        },
        {
          componentName: "House Rent Allowance",
          value: "HouseRentAllowance"
        },
        {
          componentName: "Leave Travel Allowance",
          value: "leaveTravelAllowance"
        },
        {
          componentName: "Mobile / Telephone Reimbursement",
          value: "mobileTelephoneReimbursement"
        },
        {
          componentName: "Fuel & Vehicle Maintenance",
          value: "fuelVehicleMaintenance"
        },
        {
          componentName: "Car Allowance",
          value: "carAllowance"
        }
      ],
      tableColumns: [
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Component Mapping",
          key: "componentMapping"
        },
        {
          label: "Calculated On",
          key: "calculatedOn"
        },
        {
          label: "Maximum Limit",
          key: "maxLimit"
        }
      ],
      componentList: [],
      breadcrumbList:[
        {
          name:'Organisation',
          url:`/dashboard/${this.$route.params.entity_index}/organisation`
        },{
          name:'Utilities',
          url:`/dashboard/${this.$route.params.entity_index}/organisation/utilities`
        },{
          name:'FBP Settings',
          url:`/dashboard/${this.$route.params.entity_index}/organisation/utilities/fbpsettingsandcomponentmapping`
        }
      ],
    };
  },
  activated(){
    this.fetchfbpcomponents()
  },
  mounted(){
    // this.fetchfbpcomponents()
  },
  computed:{
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else {
          return this.getleid(0);
      }
    }
  },
  methods: {
     ...mapActions({
      // submit_fbpSettings: "dashboard/organisation/utilities/fbpsettings/create",fetchcomponentbyID
      fetch_components:'dashboard/organisation/utilities/fbpsettings/fetchAllcomponents',
      fetch_component_Id:'dashboard/organisation/utilities/fbpsettings/fetchcomponentbyID'
    }),
    async editItem(e) {
      // //console.log(e);
      // fetch by id call
      try{
        let res= await this.fetch_component_Id(e.id)
        //console.log('editcomp',res)
        // debugger
        if(res.data.payload.data){
         this.rowData=res.data.payload.data
       }
      }catch(err){
        //console.log(err)
      }
      // this.rowData = e;
      this.isEditClicked = false;
    },
    onSelectFBPComponents(event) {
      //console.log(event);
    },
    async fetchfbpcomponents(){
      let res=await this.fetch_components(this.le_id)
       if(res.data.payload.data){
         this.componentList=res.data.payload.data
       }else{
        this.componentList= [
        {
          name: "House Rent Allowance",
          componentMapping: "FBP Band 0 - 5 lacs",
          calculatedOn: "Flat",
          maxLimit: "50000.00"
        },{
           name: "Meal Voucher",
          componentMapping: "FBP Band 0 - 5 lacs",
          calculatedOn: "Flat",
          maxLimit: "50000.00"
        },
        {
           name: "Hostel Allowance",
          componentMapping: "FBP Band 0 - 5 lacs",
          calculatedOn: "Flat",
          maxLimit: "50000.00"
        },
         {
           name: "Car Allowance",
          componentMapping: "FBP Band 0 - 5 lacs",
          calculatedOn: "Flat",
          maxLimit: "50000.00"
        }
        ]

         //console.log('fetch component list',res.data.payload.data)

      }
      // //console.log('ffbpcomponents',res.data)
    },
  }
};
</script>
<style lang="scss" scoped>
.noData {
  text-align: center;
  padding: 10% 0 10% 0;
  span {
    color: #858585;
    font-size: 18px;
  }
}
</style>
